var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomCard } from '../CustomCard';
import * as React from 'react';
import { CardContent, CardHeader, Switch } from 'material-ui';
import { LabeledInput } from '../LabeledInput';
import { EventType } from './types';
import { connect } from 'react-redux';
var pStyle = {
    margin: 0,
    lineHeight: '20px',
};
function renderEventType(type) {
    switch (type) {
        case EventType.APPROVED:
            return '✓';
        case EventType.INCOMING:
            return '⇐';
        case EventType.OUTGOING:
            return '…';
        case EventType.LOCAL:
            return 'X';
    }
}
var EventLog = /** @class */ (function (_super) {
    __extends(EventLog, _super);
    function EventLog(props) {
        var _this = _super.call(this, props) || this;
        _this.changeAutoScroll = function (e) {
            _this.setState({ autoScroll: e.currentTarget.checked });
        };
        _this.ref = function (el) {
            _this.element = el;
        };
        _this.state = {
            autoScroll: true,
        };
        return _this;
    }
    EventLog.prototype.render = function () {
        var entries = this.props.entries;
        return (React.createElement(CustomCard, null,
            React.createElement(CardHeader, { title: "Event log", action: this.renderAction() }),
            React.createElement("div", { ref: this.ref, style: { height: 300, overflow: 'auto', fontFamily: 'monospace' } },
                React.createElement(CardContent, null,
                    entries.length === 0 ? 'No events yet.' : null,
                    entries.map(function (e) {
                        return React.createElement("p", { style: pStyle, key: e.id },
                            renderEventType(e.type),
                            " ",
                            e.message);
                    })))));
    };
    EventLog.prototype.renderAction = function () {
        return (React.createElement(LabeledInput, { label: 'Auto scroll' },
            React.createElement(Switch, { checked: this.state.autoScroll, onChange: this.changeAutoScroll })));
    };
    EventLog.prototype.componentDidUpdate = function () {
        if (this.state.autoScroll) {
            this.element.scrollTop = 100000;
        }
    };
    return EventLog;
}(React.PureComponent));
export default connect(function (state) { return ({ entries: state.eventLog }); })(EventLog);



//////////////////
// WEBPACK FOOTER
// ./src/components/EventLog/index.tsx
// module id = 1696
// module chunks = 0